import React from 'react';
import '../../style/appointmentDetails.css';
import TestDetails from './TestDetails';
import PolicyDetails from './PolicyDetails';

export default function AppointmentDetails (props) {

    return (
        <div className='appointment-details'>
            {
                window.innerWidth > 576 && (
                    <PolicyDetails 
                        caseData={props.caseDetails}
                    />
                )
            }

            <div className='test-details-margin'>
                <TestDetails 
                    caseData={props.caseDetails}
                />
            </div>
        </div>
    );
}